export enum REQUIREMENT_NAME {
  PERSONAL = "personal",
  ANNUAL_PAPV = "annualPAPV",
  ANNUAL_PERSONAL = "annualPersonal",
  PERSONAL_PV = "personalPv",
  GROUP = "group",
  BASIS_SILVER = "basisCheckForSilverWithEq",
  BASIS_PLATINUM = "basisCheckForPlatinumWithEq",
  BASIS_FOUNDERS_PLATINUM = "basisCheckForFoundersPlatinumWithEq",
  BASIS_FOUNDERS_PLATINUM_GE = "basisCheckForFoundersPlatinumWithGe",
  BASIC_FOUNDERS_PLATINUM_AWARD = "basisCheckForFoundersPlatinumAward",
  BASIS_FOUNDERS_PLATINUM_ANA = "basisCheckForFoundersPlatinumWithEqAna",
  BASIS_FOUNDERS_PLATINUM_EMERALD = "basisCheckForFoundersPlatinumEmerald",
  BASIS_FOUNDERS_PLATINUM_EBR = "basisCheckForFoundersPlatinumEmeraldBonus",
  FOUNDERS_PLATINUM_RQ_CHECK_GE = "foundersPlatinumRqCheckUsingGe",
  FOUNDERS_PLATINUM_FT_CHECK_GE = "foundersPlatinumFtCheckUsingGe",
  BASIS_CHECK_FOR_FGI_KICKER_PLAT_EQ = "basisCheckForFgiKickerPlatinumLegGeneratorWithEq",
  BASIS_EMERALD_CHECK_GE = "basisCheckForEmeraldWithGe",
  BASIS_EMERALD_EQ = "basisCheckForEmerald",
  BASIS_DIAMOND = "basisCheckForDiamond",
  BASIS_DIAMOND_GE = "basisCheckForDiamondWithGe",
  INMARKET_FOUNDERS_DIAMOND_GE = "basisCheckForIn-marketFoundersDiamondWithEq",
  BASIS_CHECK_FOR_GOLD_WITH_EQ = "basisCheckForGoldWithEq",
  BASIS_CHECK_FOR_FOUNDERS_GOLD = "basisCheckForFoundersGoldWithEq",
  CURRENT_AWARD_PLATINUM_GE = "currentAwardCheckForPlatinumWithGe",
  PERCENTAGE_FGI = "ytdVcsPercentageCheckForfrontlineGrowthIncentive",
  PERCENTAGE_PGG = "ytdVcsPercentageCheckForPersonalGroupGrowth",
  PERCENTAGE_PPV = "ytdVcsPercentageOfPpv",
  RUBY = "ruby",
  RUBY_OPTIONAL = "ruby-optional",
  ANNUAL_RUBY = "annualRuby",
  EMERALD_BONUS_RECIPIENT = "emeraldBonusRecipient",
  EMERALD_FT_CHECK_GE = "emeraldFtCheckUsingGe",
  BASIS_CHECK_FOR_EMERALD_PARTICIPANT = "basisCheckForEmeraldParticipantWithEq",
  BASIS_CHECK_FOR_FOUNDERS_EMERALD_LE = "basisCheckForFoundersEmeraldWithLe",
  BASIS_CHECK_FOR_EMERALD_PARTICIPANT_GE = "basisCheckForEmeraldParticipantWithGe",
  IN_MARKET_FOUNDERS_EMERALD = "basisCheckForIn-marketFoundersEmeraldWithEq",
  CHECK_FOR_SILVER = "growthOrMaintainCheckForsilver",
  CHECK_FOR_PLATINUM = "growthOrMaintainCheckForPlatinum",
  CHECK_FOR_EMERALD = "growthOrMaintainCheckForemerald",
  CHECK_FOR_SAPPHIRE = "growthOrMaintainCheckForsapphire",
  LEADERSHIP_AND_FOSTER = "leadershipAndFoster",
  ANNUAL_PGG_TRACKING = "annualPggTracking",
  ANNUAL_PGGI_TRACKING = "annualPggiTracking",
  VCS_TO_PPV = "ratioOfVcsToPpvPersonalOts",
  ANNUAL_GPV = "annualGpv",
  MONTHLY_GPV = "monthlyGpv",
  NEW_FQS = "newFqs",
  DIAMOND_BONUS = "diamondBonus",
  DIAMOND_PARTICIPANT_EQ = "basisCheckForDiamondParticipantWithEq",
  MAINTAIN_GAR = "maintainGar",
  MAINTAIN_QC = "maintainQc",
  MEMBER = "member",
  VCS_PERCENT = "ratioOfVcsToPpvPersonalOts(100%-OtsPercent(bonusAward552)",
  QUALIFIED_SAPPHIRE_PIN_OR_ABOVE = "qualifiedFoundersPlatinumPin",
  IN_MARKET_Q6_LEG_GROWTH = "inmarketQ6LegGrowth",
  Q_COUNT_PERFORMANCE = "qCountPerformance",
  MAINTAIN_LS_VOLUME = "maintainLSVolume",
  BASIS_CHECK_FOR_FOUNDERS_PLATINUM = "basisCheckForFoundersPlatinum",
  BASIS_CHECK_FOR_FOUNDERS_PLATINUM_EMERALD = "basisCheckForFoundersPlatinumAndEmeraldBonus",
  PIN_REQUIREMENT = "pinRequirement",
  MAINTAIN_PIN_LEVEL = "maintainPinLevel",
  GAR_BASIS_CHECK_FOR_FOUNDERS_PLATINUM_EMERALD = "garBasisCheckForFoundersPlatinumAndEmeraldBonus",
  SAPPHIRE_RQ_CHECK_GE = "sapphireRqCheckUsingGe",
  BASIS_CHECK_SAPPHIRE_GE = "basisCheckForSapphireWithGe",
  BASIS_CHECK_FOR_GAR_EXECUTIVE_DIAMOND_GE = "basisCheckForGarExecutiveDiamondWithGe",
  BASIS_CHECK_FOR_EMERALD_WITH_EQ = "basisCheckForEmeraldWithEq",
  CURRENT_PY_CURRENT_AWARD_CHECK_EMERALD_USING_LT = "currentPYCurrentAwardCheckEmeraldUsingLt",
  EXECUTIVE_DIAMOND_BONUS = "executiveDiamondBonus",
}

export enum REQUIREMENT_TYPE {
  AWARD = "Award",
  VOLUME = "Volume",
  PERCENT = "PERCENT",
}

export enum MULTIPLIER_DATA_TYPE {
  LEG = "Leg",
  INCENTIVE = "Incentive",
}

export enum TREND {
  HIGHER = "HIGHER",
  LOWER = "LOWER",
  EQUAL = "EQUAL",
}
